(($, Drupal) => {
    Drupal.behaviors.pagination = {
        attach: function attach() {
            $(".pagination__wrapper").once("pagination").each(function() {
                const wrapper = $(this);
                const labelNext = wrapper.find(".pagination__label.next");
                const labelPrev = wrapper.find(".pagination__label.prev");
                const inputs = $(wrapper.find("input.pagination__input"));

                inputs.each(function() { 
                    const element = $(this);
                    const stateId = element.prop("id");
                    const stateName = element.prop("name");

                    if(stateId == getHashState(stateName))
                        element.prop("checked", true);
                });
                checkInputs();
                

                inputs.on("click", function() {
                    const stateName = $(this).prop("name");
                    const stateId = $(this).prop("id");
                    
                    pushHashState({ stateElement: stateId }, stateName, stateId);
                    checkInputs();
                })

               
                labelNext.on("click", function() {
                    const checkedInput = $(wrapper.find("input.pagination__input:checked"));
                    const nextInput = $(checkedInput.next().next());
                    if(nextInput.hasClass("pagination__input"))
                    {
                        const stateName = nextInput.prop("name");
                        const stateId = nextInput.prop("id");
                        pushHashState({ stateElement: stateId }, stateName, stateId);
                        nextInput.prop("checked", true);
                    } 

                    checkInputs();
                })

                
                labelPrev.on("click", function() {
                    const checkedInput = $(wrapper.find("input.pagination__input:checked"));
                    const prevInput = $(checkedInput.prev().prev());
                    if(prevInput.hasClass("pagination__input"))
                    {
                        const stateName = prevInput.prop("name");
                        const stateId = prevInput.prop("id");
                        pushHashState({ stateElement: stateId }, stateName, stateId);
                        prevInput.prop("checked", true);
                    }

                    checkInputs();
                })


                function checkInputs() {
                    const inputs = $(wrapper.find("input.pagination__input"));
                    if(checkChecked(inputs, 0))
                    {
                        labelPrev.prop("disabled", true)
                        labelNext.prop("disabled", false)
                    }
                    else if(checkChecked(inputs, inputs.length - 1))
                    {
                        labelNext.prop("disabled", true)
                        labelPrev.prop("disabled", false)
                    }
                    else {
                        labelNext.prop("disabled", false)
                        labelPrev.prop("disabled", false)
                    }
                }
                function checkChecked(inputs, index) {
                    return $(inputs[index]).prop("checked")
                }
            });
        }
    };

})(jQuery, Drupal);

